import 'intersection-observer';
import React from 'react';
import { NextPage } from 'next';
import InfoSection, { InfoSectionProps } from '../client/templates/common/info-section/InfoSection';
import HowItWorksSection, { HowItWorksSectionProps } from '../client/templates/common/how-it-works-section/HowItWorksSection';
import AppLayout from '../client/layouts/app-layout/AppLayout';
import { requireResourcesFromStaticAssets } from '../client/utils/assetsUtils';
import PageHead, { PageHeadProps } from '../client/components/page-head/PageHead';
import LogosSection, { LogosSectionProps } from '../client/templates/common/logos-section/LogosSection';
import CreateB2BLead from '../client/containers/create-b2b-lead/CreateB2bLead';
import { HeroSection } from '../client/types';
import Hero from '../client/templates/common/hero/Hero';
import { withError, withGetServerSideError } from '../client/hocs/with-server-side-error/withServerSideError';
import { importDynamicData } from '../services/importDynamicData';

export interface SellConstructorProps {
  SEO: PageHeadProps['SEO'],
  hero: HeroSection,
  infoSection: InfoSectionProps,
  howItWorksSection: HowItWorksSectionProps,
  channelsSection: LogosSectionProps,
  socialChannelsSection: LogosSectionProps,
}

const SellConstructor: NextPage<SellConstructorProps> = ({
  SEO,
  hero,
  infoSection,
  howItWorksSection,
  channelsSection,
  socialChannelsSection,
}) => (
  <AppLayout>
    <PageHead SEO={SEO} />
    <Hero
      title={hero.title}
      description={hero.description}
      secondarySlotTitle={hero.formTitle}
      backgroundImage={requireResourcesFromStaticAssets(hero.backgroundImage)}
      secondarySlot={(
        <CreateB2BLead />
        )}
    />

    <InfoSection
      title={infoSection.title}
      reasons={infoSection.reasons}
    />

    <HowItWorksSection
      title={howItWorksSection.title}
      picture={howItWorksSection.picture}
      steps={howItWorksSection.steps}
    />

    <LogosSection
      title={channelsSection.title}
      description={channelsSection.description}
      items={channelsSection.items}
      inlineItems={channelsSection.items.length}
    />

    <LogosSection
      description={socialChannelsSection.description}
      items={socialChannelsSection.items}
    />
  </AppLayout>
);

export const getServerSideProps = withGetServerSideError<SellConstructorProps>(async () => {
  const [common, data] = await Promise.all([
    importDynamicData('common.yml'),
    importDynamicData('pages/sell-constructor.yml'),
  ]);

  const { channelsSection } = common;

  return {
    props: {
      channelsSection,
      ...data,
    },
  };
});

export default withError(SellConstructor);
